import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { Editor } from 'slate';
import splitNodesAtPoint from './split-nodes-at-point';
import unwrapNodesByTypeAtRange from './unwrap-node-by-type-at-range';
import getNodesByTypeAtRange from './getNodesByTypeAtRange';
import { insertNodes } from './insertNodes';
import isEmptyParagraph from './is-empty-paragraph';

//due to some of the function of slate is not perfect now, add some custom fucntion to Editor and exported as SfEditor

var SfEditor = _objectSpread(_objectSpread({}, Editor), {}, {
  splitNodesAtPoint: splitNodesAtPoint,
  getNodesByTypeAtRange: getNodesByTypeAtRange,
  unwrapNodesByTypeAtRange: unwrapNodesByTypeAtRange,
  insertNodes: insertNodes,
  isEmptyParagraph: isEmptyParagraph
});
export { SfEditor };